<script lang="ts">
  import { Route, Router } from 'svelte-navigator';
  import { Lazy, LazyRoute, Modal } from './components';
  import { Contexts } from './contexts';

  disableFocus();

  function enableFocus() {
    document.documentElement.style.setProperty(`--outline`, '2px');
  }

  function disableFocus() {
    document.documentElement.style.setProperty(`--outline`, '0');
  }

  const ROUTES = {
    anklet: () => import('./anklet/Anklet.svelte'),
    band: () => import('./band/Band.svelte'),
    'birthstone-studs': () => import('./birthstone-studs/BirthstoneStuds.svelte'),
    'birthstone-ring': () => import('./birthstone-ring/BirthstoneRing.svelte'),
    bracelet: () => import('./bracelet/Bracelet.svelte'),
    'charm-studs': () => import('./charm-studs/CharmStuds.svelte'),
    'diamond-earrings': () => import('./diamond-earrings/DiamondEarrings.svelte'),
    'diamond-studs': () => import('./diamond-studs/DiamondStuds.svelte'),
    duet: () => import('./duet/Duet.svelte'),
    necklace: () => import('./necklace/Necklace.svelte'),
    solitaire: () => import('./solitaire/Solitaire.svelte'),
    'toi-et-moi': () => import('./toi-et-moi/ToiEtMoi.svelte'),
    trilogy: () => import('./trilogy/Trilogy.svelte'),
    trio: () => import('./trio/Trio.svelte'),

    start: () => import('./Start.svelte')
  };
</script>

<svelte:window on:mousedown={disableFocus} on:keydown={enableFocus} />
<Contexts>
  <Modal>
    <Router primary={false}>
      <Route path="/:builder" let:params>
        <Lazy component={ROUTES[params.builder] || ROUTES.start} />
      </Route>
      <LazyRoute path="/" component={ROUTES.start} />
    </Router>
  </Modal>
</Contexts>

<style>
  :root {
    --font-size: min(calc(var(--jewellery-builder-height) / 50), 18px);
    --centre-width: max(350px, calc(var(--jewellery-builder-height) / 2));
    --layout-side-padding: 1.8rem;

    --accordion-height: calc(var(--jewellery-builder-height) * 0.75);
    --start-heading-height: calc(var(--jewellery-builder-height) - var(--accordion-height));
    --start-fullscreen-height: var(--jewellery-builder-height);
    --start-fullscreen-width: var(--jewellery-builder-width);

    --loading-height: var(--jewellery-builder-height);

    --layout-height: var(--jewellery-builder-height);
    --layout-width: var(--jewellery-builder-width);
    --layout-panel-height-mobile: calc(var(--jewellery-builder-height) * 0.06);
    --layout-panel-width-desktop: var(--layout-panel-height-mobile);
    --layout-panel-width-desktop-open: 480px;

    --summary-header-height-desktop: var(--layout-panel-height-mobile);

    --builder-slide-height: calc(var(--jewellery-builder-height) * 0.4);
    --builder-item-height: calc(var(--builder-slide-height) / 5);

    --slide-nav-height: calc(var(--jewellery-builder-height) * 0.075);
  }

  @media screen and (min-width: 410px) {
    :root {
      --accordion-height: calc(var(--jewellery-builder-height) * 0.8);
    }
  }

  @media screen and (min-width: 768px) {
    :root {
      --accordion-height: calc(var(--jewellery-builder-height) * 0.75);
    }
  }
</style>
